import React, { useEffect } from 'react'

import { useTranslation } from 'language/translator'

/* Molecules */
import Breadcrumbs from 'components_new/molecules/Breadcrumbs'
import Hero from 'components_new/molecules/Hero'
import NumberCounter from 'components_new/molecules/NumberCounter'

/* Organisms */
import DashboardExampleExplorer from 'components_new/organisms/DashboardExampleExplorer'
import DashboardExampleFilterMenu from 'components_new/organisms/DashboardExampleFilterMenu'

/* Templates */
import PageLayout from 'components_new/templates/PageLayout'

/* Utils */
import { useQueryParamState } from 'utils/queryHandler'

/* Actions */
import { useDashboardExampleActions } from 'redux/actions/DashboardExamples'

/* Hooks */
import {
  useDashboardExamplesFetchStatus,
  useDashboardExamplesNrOfCustomers
} from 'redux/hooks/DashboardExamples'

const Templates = () => {
  const [search, setSearch] = useQueryParamState<string | null>('search', null)
  const [category, setCategory] = useQueryParamState<string | null>(
    'category',
    null
  )
  const [segment, setSegment] = useQueryParamState<string | null>(
    'segment',
    null
  )
  const { t } = useTranslation()

  const { tryGetAllDashboardExamples } = useDashboardExampleActions()
  const fetchStatus = useDashboardExamplesFetchStatus()
  const nrOfCustomers = useDashboardExamplesNrOfCustomers()

  useEffect(() => {
    if (fetchStatus === 'idle') {
      tryGetAllDashboardExamples()
    }
  }, [])

  return (
    <>
      <PageLayout
        content={{
          fullWidth: true
        }}
        topbar={{
          title: (
            <Breadcrumbs
              highlightCurrent={true}
              items={[
                {
                  href: '/templates',
                  icon: { name: 'Templates' },
                  title: t('global', 'templates')
                }
              ]}
            />
          )
        }}
        variant="feed"
      >
        <Hero
          body={t('dashboards', 'templates_dashboards_body')}
          sx={{ mb: 4 }}
          title={
            <>
              {t('dashboards', 'templates_dashboards_title_1')}{' '}
              <NumberCounter duration={2000} target={nrOfCustomers} />{' '}
              {t('dashboards', 'templates_dashboards_title_2')}
            </>
          }
        />

        <DashboardExampleFilterMenu
          category={category}
          search={search ?? ''}
          segment={segment}
          setCategory={setCategory}
          setSearch={(value) => setSearch(value || null)}
          setSegment={setSegment}
        />

        <DashboardExampleExplorer
          category={category}
          search={search}
          segment={segment}
        />
      </PageLayout>
    </>
  )
}

export default Templates
